import apiClient from '../../api/config/ApiClient';

const BASE_PATH = '/api/notifications';
const MIN_MARGIN_FLOOR = 1.0;
const MIN_SPREAD_FLOOR = 5.0;

/**
 * NotificationService - Telegram notification settings API
 */
class NotificationService {
  static async getSettings() {
    try {
      const response = await apiClient.get(`${BASE_PATH}/settings`);
      const data = response?.data ?? response;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: NotificationService.normalizeError(error) };
    }
  }

  static async updateSettings(payload) {
    try {
      const response = await apiClient.put(`${BASE_PATH}/settings`, payload);
      const data = response?.data ?? response;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: NotificationService.normalizeError(error) };
    }
  }

  static async generateTelegramLink() {
    try {
      const response = await apiClient.post(`${BASE_PATH}/telegram/link`);
      const data = response?.data ?? response;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: NotificationService.normalizeError(error) };
    }
  }

  static async disconnect() {
    try {
      const response = await apiClient.post(`${BASE_PATH}/telegram/disconnect`);
      const data = response?.data ?? response;
      return { data, error: null };
    } catch (error) {
      return { data: null, error: NotificationService.normalizeError(error) };
    }
  }

  static validateMinMargin(value) {
    const parsed = parseFloat(value, 10);
    if (Number.isNaN(parsed) || parsed < MIN_MARGIN_FLOOR) {
      return { valid: false, value: null };
    }
    return { valid: true, value: parsed };
  }

  static validateMinSpread(value) {
    const parsed = parseFloat(value, 10);
    if (Number.isNaN(parsed) || parsed < MIN_SPREAD_FLOOR) {
      return { valid: false, value: null };
    }
    return { valid: true, value: parsed };
  }

  static normalizeError(error) {
    const responseData = error?.response?.data;
    const message = responseData?.detail
      || responseData?.description
      || responseData?.message
      || error?.message
      || 'Request failed';

    return {
      message,
      status: error?.response?.status ?? null,
    };
  }
}

export default NotificationService;
